const DURATION_NAMES = {
    clearReelsDelay: "clearReelsDelay",
    throwReelsDelay: "throwReelsDelay",
    clearSymbolsDelay: "clearSymbolsDelay",
    throwSymbolsDelay: "throwSymbolsDelay",
    throwSymbolDuration: "throwSymbolDuration",
    condenseSymbolDuration: "condenseSymbolDuration",
    clearSymbolDuration: "clearSymbolDuration",
}

const DEFAULT = {
    clearReelsDelay: 0.045,
    throwReelsDelay: 0.09,
    clearSymbolsDelay: 0.055,
    throwSymbolsDelay: 0.055,
    throwSymbolDuration: 0.3,
    condenseSymbolDuration: 0.25,
    clearSymbolDuration: 0.07,
}

const TURBO = {
    clearReelsDelay: 0,
    throwReelsDelay: 0,
    clearSymbolsDelay: 0.025,
    throwSymbolsDelay: 0.01,
    throwSymbolDuration: 0.3,
    condenseSymbolDuration: 0.2,
    clearSymbolDuration: 0.07,
}

export const DURATIONS = {DEFAULT, TURBO, DURATION_NAMES};